import {
  INN_ERROR,
  MAX_CHARACTERS_ERROR,
  MIN_CHARACTERS_ERROR,
  OGRN_LENGTH_ERROR,
  RAFP_NZA_ERROR,
  REQUIRED_ERROR,
  UNALLOWED_CHARACTERS_ERROR,
} from 'CorePackage/MainModule/constants/validationErrors';
import { composeValidators } from 'CorePackage/MainModule/validators/composeValidators';
import { isDigitsCountCorrect } from 'CorePackage/MainModule/validators/isDigitsCountCorrect';
import { makeIsNormalInteger } from 'CorePackage/MainModule/validators/isNormalInteger';
import { makeIsOgrn } from 'CorePackage/MainModule/validators/isOgrn';
import { makeRequired } from 'CorePackage/MainModule/validators/isRequired';
import { makeSnilsValidation } from 'CorePackage/MainModule/validators/isValidSnils';
import { makeIsErknmInn } from 'CorePackage/MainModule/validators/makeIsErknmInn';
import { makeMaxCharactersValidator } from 'CorePackage/MainModule/validators/maxCharacters';
import { makeMinCharactersValidator } from 'CorePackage/MainModule/validators/minCharacters';
import { KnmSubjectTypesEnum } from 'KnmErknmPackage/ErknmSubjectModule/components/ErknmSubjectInfo';

import { IKnmFormSubject } from '../interfaces/IKnmFormSubject';

export const getKnmSubjectValidate = (subject?: IKnmFormSubject) => {
  const { ogrn, inn, isFiz, organizationName, okveds, snils, document, country, subjectTypeKnm, rafpNza, kpp } =
    subject ?? {};

  const isSubjectFIZ = subjectTypeKnm?.label === KnmSubjectTypesEnum.FIZ;
  const isSubjectUR = subjectTypeKnm?.label === KnmSubjectTypesEnum.UR;
  const isSubjectIFIZ = subjectTypeKnm?.label === KnmSubjectTypesEnum.IFIZ;
  const isSubjectIUR = subjectTypeKnm?.label === KnmSubjectTypesEnum.IUR;
  const isSubjectFIUR = subjectTypeKnm?.label === KnmSubjectTypesEnum.FIUR;

  return {
    subjectTypeKnm: composeValidators(makeRequired(REQUIRED_ERROR))(subjectTypeKnm),
    ogrn: composeValidators(
      makeIsNormalInteger(UNALLOWED_CHARACTERS_ERROR),
      makeIsOgrn(OGRN_LENGTH_ERROR, subjectTypeKnm?.label),
    )(ogrn),
    inn: composeValidators(
      makeRequired(REQUIRED_ERROR, () => !!snils || isSubjectIFIZ || isSubjectIUR || (isSubjectFIUR && !!rafpNza)),
      makeIsNormalInteger(UNALLOWED_CHARACTERS_ERROR),
      makeIsErknmInn({
        errorMessage: INN_ERROR(),
        getIsFiz: () => isFiz,
        getException: () => !inn,
      }),
    )(inn),
    snils: composeValidators(
      makeRequired(REQUIRED_ERROR, () => !!inn || !isSubjectFIZ),
      makeSnilsValidation('Поле заполнено некорректно', () => !snils),
    )(snils),
    organizationName: composeValidators(
      makeRequired(REQUIRED_ERROR, () => !(isSubjectFIZ || isSubjectIFIZ || isSubjectIUR)),
      makeMinCharactersValidator(3, MIN_CHARACTERS_ERROR(3), () => !isSubjectFIZ),
      makeMaxCharactersValidator(1017, MAX_CHARACTERS_ERROR, () => !(isSubjectFIZ || isSubjectUR || isSubjectIUR)),
      makeMaxCharactersValidator(1018, MAX_CHARACTERS_ERROR, () => !isSubjectIFIZ),
    )(organizationName),
    document: composeValidators(
      makeRequired(REQUIRED_ERROR, () => !isSubjectIFIZ),
      makeMaxCharactersValidator(1000, MAX_CHARACTERS_ERROR, () => !isSubjectIFIZ),
    )(document),
    country: makeRequired(REQUIRED_ERROR, () => !(isSubjectIUR || isSubjectIFIZ))(country),
    rafpNza: composeValidators(
      makeRequired(REQUIRED_ERROR, () => !isSubjectFIUR || !!kpp || !!inn),
      rafpNza ? makeIsNormalInteger(UNALLOWED_CHARACTERS_ERROR) : () => undefined,
      rafpNza ? isDigitsCountCorrect({ errorMessage: RAFP_NZA_ERROR, digitsCount: 11 }) : () => undefined,
    )(rafpNza),
    kpp: makeRequired(REQUIRED_ERROR, () => !isSubjectFIUR || !!rafpNza)(kpp),
    okveds: okveds?.map(okved => ({
      okved: makeRequired('Поле не может быть пустым')(okved.okved),
    })),
  };
};
